import React from 'react'
// @mui
import { Paper, Typography, Box, Tooltip, withStyles } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { CollectionToolBar } from './components'
import styles from './styles'
import { Icon } from '@iconify/react'
import { useParams } from 'react-router-dom'
import useTrackerFunction from 'src/hooks/useTrackerFunction'

const CollectionCard = props => {
  const { collection, collections, refresh, open, setOpen, classes } = props
  const history = useHistory()
  const { name, thumbnail, id: collectionId, courseCount } = collection

  // Tracking functions
  const trackCollectionClick = useTrackerFunction('clicked_collection_card')

  const handleClick = collection => {
    trackCollectionClick()
    history.push('/collection/' + collection.id + '/mini-courses')
    window.scrollTo(0, 0)
  }

  const { id } = useParams()
  const [onHover, setOnHover] = React.useState(false)

  const coverImage = thumbnail
    ? !thumbnail.includes('https://')
      ? 'https://cdn.minicoursegenerator.com/' + thumbnail
      : thumbnail
    : 'https://cdn.minicoursegenerator.com/assets/gateway/collection-cover.png'

  return (
    <Paper
      onMouseEnter={() => {
        setOnHover(true)
      }}
      onMouseLeave={() => {
        setOnHover(false)
      }}
      className={classes.collectionGalleryView}
      onClick={() => handleClick(collection)}
    >
      <div
        style={{
          backgroundImage: `url(${coverImage})`,
        }}
        className={classes.coverImage}
      />
      <div className={classes.collectionInfoContainer}>
        <div className={classes.courseCount}>
          <div className={classes.courseCountBadge}>
            <Typography className={classes.courseCountText}>
              {collection.courseCount} MINI-COURSES
            </Typography>
          </div>
          <Icon icon="lineicons:books-2" className={classes.courseCountIcon} />
        </div>
        <Tooltip
          title={collection?.name?.length > 81 ? collection?.name : ''}
          placement="bottom"
        >
          <Typography className={classes.collectionName} noWrap>
            {name}
          </Typography>
        </Tooltip>
        {id !== undefined ||
          (window.location.pathname == '/collections' && (
            <CollectionToolBar
              collection={collection}
              collections={collections}
              refresh={refresh}
              open={open}
              setOpen={setOpen}
            />
          ))}
      </div>
    </Paper>
  )
}

export default withStyles(styles)(CollectionCard)
